var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInconclusiveRatio = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91895 8.08008L7.91895 8.08008L7.91895 2.08008C4.60504 2.08008 1.91895 4.76655 1.91895 8.08008Z",
    fill: "#041231"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91895 15.0801C5.94578 15.0801 3.47902 12.9179 3.00293 10.0801L9.91895 10.0801L9.91894 3.16504C12.7567 3.64119 14.9189 6.10697 14.9189 9.08008L15.9189 9.08008C15.9189 5.21385 12.7852 2.08008 8.91894 2.08008L8.91895 9.08008L1.91895 9.08008C1.91895 12.9463 5.05272 16.0801 8.91895 16.0801L8.91895 15.0801Z",
    fill: "#041231"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99169 15.3023L15.3023 9.99166C15.3423 9.95165 15.4104 9.95426 15.4536 9.99748L16.0036 10.5474C16.0468 10.5907 16.0494 10.6588 16.0094 10.6988L10.6988 16.0094C10.6588 16.0494 10.5907 16.0468 10.5475 16.0035L9.99751 15.4536C9.9543 15.4104 9.95168 15.3423 9.99169 15.3023Z",
    fill: "#041231"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 13C15.001 11.8954 14.1055 11 13.001 11C11.8964 11 11.001 11.8954 11.001 13C11.001 14.1046 11.8964 15 13.001 15V16C11.3441 16 10.001 14.6569 10.001 13C10.001 11.3431 11.3441 10 13.001 10C14.6578 10 16.001 11.3431 16.001 13C16.001 14.6569 14.6578 16 13.001 16V15C14.1055 15 15.001 14.1046 15.001 13Z",
    fill: "#041231"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInconclusiveRatio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inconclusive_ratio.8bee3940.svg";
export { ForwardRef as ReactComponent };